import React from "react";
import { useParams } from "react-router-dom";
import { employees } from "./NhanSu_PB";
import {
  CTable,
  CTableHead,
  CTableRow,
  CTableHeaderCell,
  CTableBody,
  CTableDataCell,
  CButton,
} from "@coreui/react";
import { Link } from "react-router-dom";

const PbChiTiet = () => {
  const { id } = useParams();
  const departmentId = parseInt(id, 10);

  const employeesInDepartment = employees.filter(
    (emp) => emp.departmentId === departmentId
  );

  return (
    <div>
      <div className="d-flex justify-content-end gap-2 mb-3">
        <Link to={``}>
          <CButton color="info" variant="outline" size="lg">
            Thêm nhân sự
          </CButton>
        </Link>
        <Link to={`/tao_lich`}>
          <CButton color="warning" variant="outline" size="lg">
            Tạo lịch làm việc
          </CButton>
        </Link>
      </div>
      <h2>Danh sách nhân sự của phòng ban {departmentId}</h2>
      <CTable striped hover responsive>
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell>#</CTableHeaderCell>
            <CTableHeaderCell>Tên</CTableHeaderCell>
            <CTableHeaderCell>Mã</CTableHeaderCell>
            <CTableHeaderCell>Điện thoại</CTableHeaderCell>
            <CTableHeaderCell>Email</CTableHeaderCell>
            <CTableHeaderCell>Vị trí</CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {employeesInDepartment.length > 0 ? (
            employeesInDepartment.map((employee, index) => (
              <CTableRow key={employee.id}>
                <CTableDataCell>{index + 1}</CTableDataCell>
                <CTableDataCell>{employee.name}</CTableDataCell>
                <CTableDataCell>{employee.code}</CTableDataCell>
                <CTableDataCell>{employee.phone}</CTableDataCell>
                <CTableDataCell>{employee.email}</CTableDataCell>
                <CTableDataCell>{employee.position}</CTableDataCell>
              </CTableRow>
            ))
          ) : (
            <CTableRow>
              <CTableDataCell colSpan="6" style={{ textAlign: "center" }}>
                Không có nhân sự trong phòng ban này.
              </CTableDataCell>
            </CTableRow>
          )}
        </CTableBody>
      </CTable>
    </div>
  );
};

export default PbChiTiet;
